import {
  DurationFilterOptions,
  FilterDocument,
  FilterDocumentDurationFilter,
  FilterDocumentDurationTypes,
} from '@griply/types';

const toMilliseconds = (
  value: number,
  type: FilterDocumentDurationTypes,
): number =>
  value * (type === FilterDocumentDurationTypes.Minutes ? 1 : 60) * 60 * 1000;

export const getDurationFilterOptions = (
  durationFilter: FilterDocumentDurationFilter | null | undefined,
): DurationFilterOptions => ({
  minDuration: durationFilter?.more?.value
    ? toMilliseconds(durationFilter.more.value, durationFilter.more.type)
    : undefined,
  maxDuration: durationFilter?.less?.value
    ? toMilliseconds(durationFilter.less.value, durationFilter.less.type)
    : undefined,
  noDuration: durationFilter?.noDuration ? true : undefined,
  hasDuration: durationFilter?.hasDuration ? true : undefined,
});

// One duration-options entry per filter set (the main set + each `or` branch),
// for per-occurrence filtering in the multi-occurrence builders.
export const getDocumentDurationFilters = (
  filterDocument: FilterDocument | null | undefined,
): DurationFilterOptions[] =>
  [
    filterDocument?.filters?.duration,
    ...(filterDocument?.or ?? []).map((branch) => branch.duration),
  ].map(getDurationFilterOptions);
